import { Button, Col, Container, Row } from "react-bootstrap";
import './Booking.scss';
import { MainHomeIcon } from "../assets/icons/main-home-icon";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";


const Booking = () => {
  const { t } = useTranslation(["translation", "de"])
  const navigate = useNavigate();

  return (
    <>
      <div className="booking-container" >
        {/* Decorative SVG elements */}
        <div className="hero-decoration">
          <svg className="deco-circle deco-circle--1" viewBox="0 0 200 200" fill="none">
            <circle cx="100" cy="100" r="98" stroke="#B8860B" strokeWidth="0.5" opacity="0.15"/>
            <circle cx="100" cy="100" r="70" stroke="#B8860B" strokeWidth="0.3" opacity="0.1"/>
          </svg>
          <svg className="deco-circle deco-circle--2" viewBox="0 0 200 200" fill="none">
            <circle cx="100" cy="100" r="98" stroke="#B8860B" strokeWidth="0.5" opacity="0.1"/>
          </svg>
          <svg className="deco-dots" viewBox="0 0 100 100" fill="none">
            {[...Array(5)].map((_, row) =>
              [...Array(5)].map((_, col) => (
                <circle key={`${row}-${col}`} cx={10 + col * 20} cy={10 + row * 20} r="1.5" fill="#B8860B" opacity="0.2"/>
              ))
            )}
          </svg>
          <div className="deco-line deco-line--1" />
          <div className="deco-line deco-line--2" />
        </div>

        <Container className="booking-content">
          <Row>
            <Col md={6} className="booking-container__left col-md-6 col-12 order-2 order-md-1">
              <motion.div
                className="hero-badge"
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M8 0L10.12 5.88L16 8L10.12 10.12L8 16L5.88 10.12L0 8L5.88 5.88L8 0Z" fill="#B8860B"/>
                </svg>
                <span>Engineering Excellence</span>
              </motion.div>
              <motion.h1
                className="booking-container__left__title"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
              >
                {t('booking.title')}
              </motion.h1>
              <motion.div className="hero-gold-line"
                initial={{ width: 0 }}
                animate={{ width: 80 }}
                transition={{ duration: 0.8, delay: 0.3 }}
              />
              <motion.p
                className="booking-container__left__subtitle"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.3, ease: "easeOut" }}
              >
                {t('booking.subtitle')}
              </motion.p>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.5, ease: "easeOut" }}
              >
                <Button onClick={() => navigate('contact-us')} className="booking-container__left__button">
                  <span>{t('booking.button')}</span>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                  </svg>
                </Button>
              </motion.div>
            </Col>
            <Col md={6} className="booking-container__right col-md-6 col-12 order-1 order-md-2">
              <motion.span
                className="companypicture"
                initial={{ opacity: 0, scale: 0.85 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 1.2, delay: 0.2, ease: "easeOut" }}
              >
                <MainHomeIcon />
              </motion.span>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Booking;
